import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';

import { observer } from 'mobx-react';
import { sanitizeHtml } from '@roc/ui/utils';
import { ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: '-18px',
  },
  containerV2: {
    marginTop: '16px'
  },
  alert: {
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
  inlineItemTypography: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21.98px',
    letterSpacing: '0.1px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  }
}));

export const BannerMessages = observer((props) => {
  const classes = useStyles();
  const { messages, isInlineItem, isBlueBanner } = props;
  const { newDesignForSummaryScreen } = props;

  const containerClassName = newDesignForSummaryScreen
    ? undefined
    : isInlineItem ? classes.containerV2 : classes.container;

  return (
    <>
      {messages?.length > 0 ? (
        <>
          <Box className={containerClassName}>
            {messages.map((message, index) => {
              const content = message.content;
              return (
                <Alert
                  key={index}
                  severity={isBlueBanner ? 'info' : 'warning'}
                  icon={newDesignForSummaryScreen ? <ErrorOutline fontSize="inherit" /> : undefined}
                  className={classes.alert}
                >
                  <AlertTitle>{message.title}</AlertTitle>
                  <Typography component="div" variant="body2" className={isInlineItem ? classes.inlineItemTypography : ''}>
                    {typeof content === 'string' ? (
                      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
                    ) : (
                      content
                    )}
                  </Typography>
                </Alert>
              );
            })}
          </Box>
          <br />
        </>) : <Grid />
      }
    </>
  );
});
